import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthorizationService } from '~ngx-shared/authentication';
import { AuthorizationUtil, RoleEnum } from '~shared/utils';

export function notificationResolver(): ResolveFn<any | undefined | null> {
  return (route, state) => {
    const authorizationService = inject(AuthorizationService);
    return {
      conditions: [
        {
          _or: [
            {
              active_latest_education_office_data: {}
            },
            {
              active_latest_school_office_data: {}
            },
            {
              active_latest_inspector_data: {}
            },

            ...(authorizationService.can(AuthorizationUtil.GROUP_INSPECTOR)
              ? [
                  {
                    active_latest_teacher_data: {}
                  }
                ]
              : [])
          ]
        }
      ],
      options: [
        RoleEnum.EDUCATION_OFFICE,
        RoleEnum.SCHOOL_OFFICE,
        RoleEnum.INSPECTOR,
        ...(authorizationService.can(AuthorizationUtil.GROUP_INSPECTOR) ? [RoleEnum.TEACHER] : [])
      ]
    };
  };
}
